// extracted by mini-css-extract-plugin
module.exports = {"detail":"injection_detail__kovvi","field":"injection_field__JoQJy","verifyButton":"injection_verifyButton__2inIC","rejected":"injection_rejected__mu_hq"};